// Desabling the rule as the default values are initialized in desctructuring block of props object
/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Banner from '/component/base/Banner';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {Shared} from '/constant/TestIDs';
import {withTheme} from '/provider/ThemeProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './MessageBanner.style';

interface MessageBannerComponentProps {
  getTheme: (destination: string) => object;
  style: {
    base: object;
    icon: object;
    contentContainer: object;
    text: object;
  };
  alertLevel?: 'low' | 'info' | 'important' | 'success' | 'error';
  alertSucessBg: boolean;
  useCompetency?: boolean;
  bannerClose?: () => void;
  closeIconTestID?: string;
  iconName?: string;
  message?: string;
  verticalBanner?: boolean;
}

export const MessageBanner = (props: MessageBannerComponentProps) => {
  const {
    getTheme,
    style: styleProp = {base: {}, text: {}, icon: {}, contentContainer: {}},
    alertLevel = 'info',
    alertSucessBg = false,
    useCompetency = false,
    bannerClose = noop,
    closeIconTestID,
    iconName = '',
    message = '',
    verticalBanner = false,
  } = props;
  let iconStyle = {...styles.icon};

  if (alertLevel === 'low') {
    iconStyle = {...iconStyle, ...styles.low};
  } else if (alertLevel === 'info') {
    iconStyle = {...iconStyle, ...styles.info};
  } else if (alertLevel === 'important') {
    iconStyle = {...iconStyle, ...styles.important};
  } else if (alertLevel === 'success') {
    iconStyle = {...iconStyle, ...styles.success};
  } else if (alertLevel === 'error') {
    iconStyle = {...iconStyle, ...styles.error};
  }

  if (useCompetency) {
    iconStyle = {...iconStyle, ...getTheme('competency.bannerColors.icon')};
  }
  return (
    <Banner
      style={{...styles.base, ...(styleProp.base || {})}}
      alertLevel={alertLevel}
      alertSucessBg={alertSucessBg}
      useCompetency={useCompetency}
      bannerClose={bannerClose}
      closeIconTestID={closeIconTestID}
      verticalBanner={verticalBanner}>
      <View
        style={{
          ...styles.contentContainer,
          ...(styleProp.contentContainer || {}),
        }}
        {...testProperties(Shared.sharedMessageBannerView)}>
        {!!iconName && (
          <Icon
            name={iconName}
            style={{...iconStyle, ...(styleProp.icon || {})}}
            testID="icon"
          />
        )}
        <Text
          testID={Shared.sharedMessageBanner}
          style={{...styles.text, ...(styleProp.text || {})}}>
          {message}
        </Text>
      </View>
    </Banner>
  );
};

export default withTheme(MessageBanner);
